export const BUILD = {
    version: '3.14.12',
    date: 'Tue Apr 18 2023 06:58:49 GMT+0000 (Coordinated Universal Time)'
};
//# sourceMappingURL=build.js.map